import { createGlobalStyle } from 'styled-components';

/*
 * Pretendard Variable은 public/index.html에서 <link>로 불러온다.
 * styled-components가 주입하는 스타일 안에서 @import를 쓰면 렌더링을 막고
 * 브라우저에 따라 무시되기도 해서 문서 <head>에 두는 편이 안전하다.
 */
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, sans-serif;
    background-color: #ffffff;
    color: ${props => props.theme.colors.textMain};
    font-size: ${props => props.theme.type.body};
    font-weight: ${props => props.theme.weight.body};
    line-height: 1.75;
    letter-spacing: ${props => props.theme.tracking.body};
    /* 한글을 어절(단어) 단위로 줄바꿈. 단, 너무 긴 문자열은 예외적으로 끊어 오버플로 방지 */
    word-break: keep-all;
    overflow-wrap: break-word;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /*
   * 제목은 본문보다 자간을 더 좁히고 행간을 붙인다.
   * 각 페이지에서 크기만 정하면 나머지 조판은 여기서 일괄로 잡힌다.
   *
   * color는 절대 지정하지 않는다. 배너·사이드바·푸터처럼 어두운 배경을 쓰는 곳은
   * 부모에 color: white만 주고 제목이 이를 상속받는 구조라서,
   * 여기서 색을 박으면 그 상속이 끊겨 어두운 배경에 검은 글씨가 된다.
   */
  h1, h2, h3, h4, h5, h6 {
    font-weight: ${props => props.theme.weight.heavy};
    line-height: 1.2;
    letter-spacing: ${props => props.theme.tracking.title};
  }

  h4, h5, h6 {
    letter-spacing: ${props => props.theme.tracking.card};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  /* 숫자를 고정폭으로 정렬해 조회수·연도 같은 수치가 흔들리지 않게 한다 */
  table, time {
    font-variant-numeric: tabular-nums;
  }
`;

export default GlobalStyle;
